export default __webpack_public_path__ + "static/media/sickkids_banner.89a55b01.jpeg";